/**
 * abstraction for user access token acquiring
 * @returns {string}
 */
const getAccessToken = () => localStorage.getItem('access_token')

export default getAccessToken



// WEBPACK FOOTER //
// ./src/lib/utils/getAccessToken.js